import { render } from "./Quill.vue?vue&type=template&id=28ae6dea&lang=html"
import script from "./Quill.vue?vue&type=script&lang=js"
export * from "./Quill.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__